






















import Vue from 'vue';

export default Vue.extend({
  name: 'NotificationEmitter',
  props: {
    initialMessage: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    if (this.initialMessage) {
      const { text, status } = this.initialMessage;
      if (!!text && status === 'success') this.$notifySuccess(text);
      if (!!text && status === 'danger') this.$notifyError(text);
    }
  },
});
